import React, { useEffect } from 'react'

import { closest, isNullOrUndefined, remove, removeClass } from '@syncfusion/ej2-base';
import { ContextMenuComponent, MenuItemModel } from '@syncfusion/ej2-react-navigations';
import { useInstData } from 'tyan/public/hooks';

const indexID = '__index'
const indexItems = [{ id: indexID }]

/**
 * 返回：{
 *   items: 新生成的菜单数组
 *   disableIDs: disable菜单id数组
 *   handlerMap: 菜单项回调map: {id1:callback1, ...}
 * }
 * @param {*} source, 原始菜单配置(数组)
 * @param {*} data, 回调函数所用数据
 * @param {*} prefix, 上级id前缀
 */
const genMenuItems = (source, data, prefix = '_') => {
	const calcProp = (prop) => prop && typeof prop === 'function' ? prop(data) : prop

	let items = [], disabledIDs = [], handlerMap = {}
	source && source.forEach(({ text, icon, disabled, cdt, handler, items: subSourceItems }, index) => {
		if (cdt && !cdt(data)) return

		const id = `${prefix}${index}`
		const item = {
			text: calcProp(text),
			id
		}
		true && (icon = calcProp(icon)) && (item.iconCss = `t-fa fa-${icon}`)

		if (subSourceItems) {
			const { items: subItems, disabledIDs: subDisabledIDs, handlerMap: subHandlerMap } = genMenuItems(subSourceItems, data, `${id}_`)
			if (!subItems.length) return
			item.items = subItems
			subDisabledIDs.length && (disabledIDs = disabledIDs.concat(subDisabledIDs))
			handlerMap = { ...handlerMap, ...subHandlerMap }
		} else {
			true && (disabled = calcProp(disabled)) && disabledIDs.push(id)
			handlerMap[id] = handler
		}

		items.push(item)
	})
	return { items, disabledIDs, handlerMap }
}
/**
 * filter: 以空格分隔的CSS类名, 如'e-work-cells e-appointment', 如果要有并列的CSS类名，如使用'.a.b'则为'a.b'，这是由syncfusion MenuBase制定的规则
 * contextMenu:形如{text, icon, disabled, cdt, handler, items}
 *   handler 与 items 二选一，items优先，即如果有items则handler无效
 *   handler, cdt 只能为回调函数
 *   items 为子项数组
 *   text, icon, disabled 均可为直接值或回调函数
 *   回调函数形式为 func(data)，其中data由onGetData生成
 * @param {*} props 
 */
const ContextMenu = props => {
	const { target, filter, contextMenu, onGetData, onRegisterContextMenu } = props
	const { me } = useInstData(props)

	const onMenuItemSelect = args => {
		const { handlerMap: { [args.item.id]: handler } = {}, data } = me
		handler && handler(data)
	}

	const onContextMenuBeforeOpen = args => {
		// 清除所有菜单
		const menuObj = me.menuObj
		const ids = menuObj.items.map(o => o.id)
		ids.shift()
		ids.length && menuObj.removeItems(ids, true)

		// 取数据
		// ???
		// let newEventElement = document.querySelector('.e-new-event');
		// if (newEventElement) {
		// 	remove(newEventElement);
		// 	removeClass([document.querySelector('.e-selected-cell')], 'e-selected-cell');
		// }
		let targetElement = args.event.target;
		// ???
		if (closest(targetElement, '.e-contextmenu')) {
			return;
		}

		const selectedTarget = filter ? closest(targetElement, filter.split(' ').filter(o => o).map(o => `.${o}`).join(', ')) : targetElement
		if (isNullOrUndefined(selectedTarget)) {
			args.cancel = true;
			return;
		}

		const data = me.data = onGetData && onGetData(selectedTarget)

		// 组织菜单及调用句柄
		const { items, disabledIDs, handlerMap } = genMenuItems(contextMenu, data)

		if (!items.length) {
			args.cancel = true;
			return
		}
		me.handlerMap = handlerMap

		// 插入菜单并置disabled
		menuObj.insertAfter(items, indexID, true)
		disabledIDs.length && menuObj.enableItems(disabledIDs, false, true)
	}

	useEffect(() => {
		me.menuObj.hideItems([indexID], true)
		return () => { me.menuObj.destroy() }
	}, [])

	return <ContextMenuComponent ref={menu => menu && me.menuObj !== menu && (me.menuObj = menu, onRegisterContextMenu && onRegisterContextMenu(menu))}
		target={target} filter={filter}
		items={indexItems} beforeOpen={onContextMenuBeforeOpen} select={onMenuItemSelect}
	/>
}

export default ContextMenu